"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const assured_1 = __importDefault(require("../../assured"));
const user_1 = __importDefault(require("../../user"));
class PartnerUser {
    constructor(user, assured, cardInfo, newUser) {
        this.user = user;
        this.assured = assured;
        this.cardInfo = cardInfo;
        this.newUser = newUser;
    }
    static fromObj(data) {
        var _a;
        const assuredData = (_a = data.assured) !== null && _a !== void 0 ? _a : data.certificateHolder;
        return new PartnerUser(data.user ? user_1.default.fromObj(data.user) : undefined, assuredData ? assured_1.default.fromObj(assuredData) : undefined, data.cardInfo, !!data.newUser);
    }
}
exports.default = PartnerUser;
//# sourceMappingURL=partnerUser.class.js.map